import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 88px 0;
  background: #fff;

  @media (max-width: 990px) {
    padding: 64px 0;
  }
  @media (max-width: 767px) {
    padding: 48px 0;
  }
`;

export const Intro = styled.div`
  max-width: 760px;
  margin: 0 auto 48px;
  text-align: center;

  > span {
    display: block;
    margin-bottom: 8px;
    color: #46679f;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.15em;
  }

  h2 {
    margin: 0 0 16px;
    color: #0f2137;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.03em;
  }

  p {
    margin: 0;
    color: #5d646d;
    font-size: 17px;
    line-height: 1.75;
  }

  @media (max-width: 767px) {
    margin-bottom: 32px;
    h2 {
      font-size: 24px;
    }
    p {
      font-size: 16px;
    }
  }
`;

export const TopicGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
`;

export const Topic = styled.article`
  padding: 24px;
  border: 1px solid #e3eaf5;
  border-radius: 10px;
  background: #f7faff;

  h3 {
    margin: 0 0 10px;
    color: #0f2137;
    font-size: 19px;
    font-weight: 600;
    letter-spacing: -0.01em;
  }

  p {
    margin: 0;
    color: #343d48cc;
    font-size: 15px;
    line-height: 1.7;
  }

  /* Progressive entrance, CSS only. Skipped when the browser lacks
     scroll-driven animations or the visitor prefers reduced motion. */
  @supports (animation-timeline: view()) {
    @media (prefers-reduced-motion: no-preference) {
      animation: topic-rise linear both;
      animation-timeline: view();
      animation-range: entry 0% entry 40%;
    }
  }

  @keyframes topic-rise {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }
`;

export const Notes = styled.div`
  max-width: 760px;
  margin: 32px auto 0;
  text-align: center;

  p {
    margin: 0 0 12px;
    color: #343d48;
    font-size: 15px;
    line-height: 1.75;
  }

  a {
    display: inline-block;
    margin-top: 6px;
    color: #335d9f;
    font-weight: 600;
  }
`;

export const Shots = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 40px;
  margin-top: 48px;

  figure {
    margin: 0;
  }

  /* The screens are dense 1600 px captures, so each one takes the full
     column, one under the other. */
  figcaption {
    margin-top: 12px;
    color: #5d646d;
    font-size: 14px;
    line-height: 1.6;
    text-align: center;
  }

  @media (max-width: 767px) {
    gap: 32px;
    margin-top: 32px;
  }
`;
